






















































import {Vue, Component, PropSync} from 'vue-property-decorator';

@Component
export default class AccessControlLayerPopup extends Vue {
	@PropSync('showIpAccessControlNotice')
	private showIpAccessControlNoticeSync: boolean;
}
